import React, { useState } from 'react';
import { TouchableOpacity, View } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { Icon, IconTypes } from '../Icon';
import { ShimmerWrapper } from '../Shimmer';
import { Images, Colors, useTheme } from '../Themes';
import { TypesList, Types } from '../Themes/Types';
import VFButton from '../VFButton';
import VFText from '../VFText';

import styles from './VFBanner.Styles';
import { VFBannerLoadingConfig } from './VFBannerLoading/VFBannerLoading.config';

function VFBanner({
  backgroundColors,
  title,
  description,
  primaryButtonTitle,
  onPrimaryButtonPress,
  secondaryButtonTitle,
  onSecondaryButtonPress,
  withPrimaryButton,
  withSecondaryButton,
  leftIconType,
  leftIcon,
  leftIconSize,
  renderRightComponent,
  containerViewStyle,
  closeIconSize,
  textPrimaryButtonStyle,
  primaryButtonViewStyle,
  titleStyle,
  descriptionStyle,
  setIsPageBannerVisible,
  withCloseButton,
  withLeftIcon,
  leftIconStyle,
  bannerTestID,
  closeIconTestID,
  extraGradientProps,
  titlePlaceholders,
  iconAndTitleContainerStyle,
  type,
  isLoading,
  ...props
}) {
  const theme = useTheme();
  const [showBanner, setShowBanner] = useState(true);

  const hideBanner = () => {
    setShowBanner(false);
    _isFunction(setIsPageBannerVisible) && setIsPageBannerVisible(false);
  };
  const renderGradientWrapper = ({ children }) => {
    return (
      <LinearGradient
        colors={backgroundColors}
        style={[styles.containerStyle, containerViewStyle]}
        start={{ x: 0, y: 1 }}
        end={{ x: 1, y: 0 }}
        {...extraGradientProps}
      >
        {children}
      </LinearGradient>
    );
  };
  const renderPrimaryWrapper = ({ children }) => {
    return (
      <View style={[styles.containerStyle, styles.primaryBackground(theme), containerViewStyle]}>
        {children}
      </View>
    );
  };
  const isGradient = type === Types.GRADIENT;
  const BackgroundWrapper = isGradient ? renderGradientWrapper : renderPrimaryWrapper;

  const renderLoading = () => {
    return (
      <ShimmerWrapper
        isLoading={true}
        loadingConfig={VFBannerLoadingConfig}
        containerStyle={[styles.loadingContainerStyle(theme), containerViewStyle]}
      />
    );
  };

  const renderBanner = () => {
    return (
      <BackgroundWrapper>
        <View style={styles.titleContainer} testID={bannerTestID}>
          <View style={[styles.iconAndTitleContainer, iconAndTitleContainerStyle]}>
            {withLeftIcon && (
              <Icon
                type={leftIconType}
                name={leftIcon}
                size={leftIconSize}
                style={[styles.leftIconStyle, leftIconStyle]}
              />
            )}
            <VFText
              i18nKey={title}
              style={[styles.title, titleStyle]}
              type={isGradient ? 'secondary' : 'primary'}
              placeHolders={titlePlaceholders}
            />
            {_isFunction(renderRightComponent) && renderRightComponent()}
          </View>
          {withCloseButton && (
            <TouchableOpacity testID={FoundationTestKeys.VFBannerCloseButton} onPress={hideBanner}>
              <Icon
                type={IconTypes.image}
                name={Images.ic_small_close_white}
                size={closeIconSize}
                testID={closeIconTestID}
              />
            </TouchableOpacity>
          )}
        </View>
        <VFText
          i18nKey={description}
          style={[styles.description, descriptionStyle]}
          type={isGradient ? 'secondary' : 'primary'}
        />
        <View style={styles.buttonsContainer}>
          {withPrimaryButton && (
            <VFButton
              style={[
                [styles.buttonStyle, primaryButtonViewStyle],
                withSecondaryButton && styles.primaryButtonStyle,
              ]}
              textStyle={[styles.textButtonStyle, textPrimaryButtonStyle]}
              title={primaryButtonTitle}
              onPress={onPrimaryButtonPress.bind(this, hideBanner)}
              type={isGradient ? 'primaryWhite' : 'primary'}
            />
          )}

          {withSecondaryButton && (
            <VFButton
              style={[styles.buttonStyle]}
              textStyle={styles.textButtonStyle}
              title={secondaryButtonTitle}
              onPress={onSecondaryButtonPress.bind(this, hideBanner)}
              type={isGradient ? 'quinary' : 'quaternary'}
            />
          )}
        </View>
      </BackgroundWrapper>
    );
  };

  return (
    showBanner && (
      <View>
        {isLoading && renderLoading()}

        {!isLoading && renderBanner()}
      </View>
    )
  );
}
VFBanner.defaultProps = {
  backgroundColors: [Colors.darkRedTwo, Colors.vfRed],
  closeIconSize: 20,
  withCloseButton: true,
  withLeftIcon: false,
  withPrimaryButton: true,
  onPrimaryButtonPress: () => null,
  onSecondaryButtonPress: () => null,
  type: Types.GRADIENT,
  isLoading: false,
};
VFBanner.propTypes = {
  backgroundColors: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  primaryButtonTitle: PropTypes.string.isRequired,
  onPrimaryButtonPress: PropTypes.func,
  secondaryButtonTitle: PropTypes.string,
  onSecondaryButtonPress: PropTypes.func,
  withPrimaryButton: PropTypes.bool,
  withSecondaryButton: PropTypes.bool,
  leftIconType: PropTypes.string,
  leftIcon: PropTypes.object,
  leftIconSize: PropTypes.number,
  renderRightComponent: PropTypes.func,
  containerViewStyle: ViewPropTypes.style,
  closeIconSize: PropTypes.number,
  textPrimaryButtonStyle: TextPropTypes.style,
  primaryButtonViewStyle: ViewPropTypes.style,
  iconAndTitleContainerStyle: ViewPropTypes.style,
  titleStyle: TextPropTypes.style,
  descriptionStyle: TextPropTypes.style,
  leftIconStyle: ViewPropTypes.style,
  setIsPageBannerVisible: PropTypes.func,
  withCloseButton: PropTypes.bool,
  withLeftIcon: PropTypes.bool,
  bannerTestID: PropTypes.string,
  closeIconTestID: PropTypes.string,
  extraGradientProps: PropTypes.object,
  titlePlaceholders: PropTypes.arrayOf(PropTypes.string),
  type: PropTypes.oneOf(TypesList),
  isLoading: PropTypes.bool,
};

export default VFBanner;
